export const loginRedirectUrl = '/login'
export const appUrl = process.env.REACT_APP_APP_URL
export const assetUrl = process.env.REACT_APP_ASSET_URL
